var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('router-view',{staticClass:"mx-5",attrs:{"loginParams":_vm.loginParams},on:{"login":function($event){_vm.loginParams = $event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }